// Editable content for Everybit home landing
export const brandName = 'Everybit';
export const contactEmail = 'jung@everybit.dev';

export const heroHeading = 'Everybit';
export const heroSubtext = `software consulting
We finished every project we started.
Do you have a project in mind?
Let's talk.`;

export const nav = {
  contact: 'Contact',
};
